import type { RawValidResponse } from '../../goodstack'

import { RewardRuleSimulation, SimulateAccountRewardsParams } from './simulateAccountRewards.types'
import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export const simulateAccountRewards: QueryFn<
  ['simulateAccountRewards', SimulateAccountRewardsParams | null],
  RewardRuleSimulation[]
> = async (client, [_, params]) => {
  if (!params) {
    return []
  }

  const res = await client.post<RawValidResponse<RewardRuleSimulation[]>>(
    'v1/account/gamification/rewards/simulate-many',
    params,
    { withCredentials: true }
  )

  return res.data.data
}
